"use client";

import dynamic from "next/dynamic";
import { useLazyLoad, LAZY_LOAD_CONFIGS } from "@hooks/useLazyLoad";

const EMICalculatorClientWrapper = dynamic(() => import("./EMICalculatorClientWrapper"), {
  ssr: false,
  loading: () => (
    <div className="emi-calculator-skeleton" style={{ 
      height: '400px', 
      background: '#f5f5f5', 
      borderRadius: '8px', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: '#666'
    }}>
      Loading EMI Calculator...
    </div>
  ),
});

export default function EMICalculatorClientLazy(props: any) {
  const shouldLoad = useLazyLoad(LAZY_LOAD_CONFIGS.EMI_CALCULATOR);

  if (!shouldLoad) {
    return (
      <div style={{ 
        height: '400px', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
        borderRadius: '12px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        color: 'white',
        fontSize: '16px',
        fontWeight: '500'
      }}>
        📊 EMI Calculator
      </div>
    );
  }

  return <EMICalculatorClientWrapper {...props} />;
} 